export const DOOSAN_SSO = 'cloudmpsso';
export const DOOSAN_PORTAL = 'cloudmpservice';
export const DOOSAN = '.doosan.com';
export const DOOSAN_CONSOLE = 'cloudmpconsole';

export const SCMP_SSO = 'scmpsso';
export const SCMP_PORTAL = 'scmpservice';
export const SCMP = '.sec.samsung.net';

export const HYUNDAIMOVEX_SSO = 'cloudsso';
export const HYUNDAIMOVEX_PORTAL = 'cloudservice';
export const HYUNDAIMOVEX = '.hyundaimovex.com';

export const SCK_PORTAL = 'msp';
export const SCK = '.sckcorp.co.kr';

export const SPIN_PORTAL = 'msp';
export const SPIN = '.spintech.co.kr';

export const COMTEC_PORTAL = 'oasis';
export const COMTEC = '.comtec.co.kr';

export const WINS21_PORTAL = 'cloudservice';
export const WINS21 = '.wins21.com';

export const HMG_SSO = 'sso-cmp';
export const HMG_PORTAL = 'service-cmp';
export const HMG = '.hmg.net';
export const HMG_NEW = '.hmg-corp.io';


// WEBPACK FOOTER //
// ./src/constants/urlConstants.js